module.exports = __webpack_public_path__ + "img/4.624e7498.jpg";